import Typography from "@mui/material/Typography";
import { styled } from "@mui/material";

export const ValueUnitValue = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  fontVariantNumeric: "tabular-nums",
}));

export const ValueUnitUnit = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[120],
}));
